import { CommonModule, NgStyle } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule, Router, NavigationEnd } from '@angular/router';

import { filter, tap } from 'rxjs';

import { ProjectFilterTypeService } from '../../services/project-filter-type.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.less'],
  standalone: true,
  imports: [NgStyle, RouterModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent implements AfterViewInit {
  private readonly router = inject(Router);
  private readonly projectFilterTypeService = inject(ProjectFilterTypeService);

  // Proxy to the service's isAllProject signal
  protected readonly isAllProject = this.projectFilterTypeService.isAllProject;

  // Setup navigation end handler
  private readonly _navigationEndHandler = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      tap(() => {
        this.updateActiveLine();
      })
    )
  );

  /**
   * headerActiveLineLeft - изменяет положение по левому краю ползунка
   */
  protected readonly headerActiveLineLeft = signal<number>(0);

  /**
   * headerActiveLineWidth - изменяет длину ползунка относительно длины выбранного элемента
   */
  protected readonly headerActiveLineWidth = signal<number>(0);

  ngAfterViewInit(): void {
    // Инициализация начального положения
    this.updateActiveLine();
  }

  /**
   * Обновляет положение и размер активной линии
   */
  private updateActiveLine(): void {
    // Используем setTimeout с небольшой задержкой для гарантии обновления DOM
    setTimeout(() => {
      const element = document.getElementsByClassName('menu__item_active')[0] as HTMLElement;

      if (element) {
        this.headerActiveLineWidth.set(element.clientWidth + 10);
        this.headerActiveLineLeft.set(element.offsetLeft - 6);
      }
    }, 50);
  }
}
